import { Button, MyIcon } from 'ccs-ui-components';
import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { IngressEvent, ServiceOperation } from '../../../store/_api/TypeDefs';
import { FlowItemDataMap, SidebarDataLoadingState } from '../../../modules/journey-canvas/utility/TypeDefs';
import JourneyCanvasIngressEventItem from '../../journey-canvas-event-item/JourneyCanvasIngressEventItem';

import classes from './IngressEvents.module.scss';

interface IngressEventsProps {
  hideSidebar: () => void;
  flowItemDataMap: FlowItemDataMap;
  ingressNodeId: string;
  serviceOperations: ServiceOperation[];
  ingressEventClickHandler: (serviceOps: ServiceOperation, ingressEvent: IngressEvent) => void;
  sidebarDataLoadingState: SidebarDataLoadingState;
  readOnly?: boolean;
}

const IngressEvents = ({ hideSidebar, flowItemDataMap, ingressNodeId, serviceOperations, ingressEventClickHandler, sidebarDataLoadingState, readOnly = false }: IngressEventsProps) => {
  const { t: translate } = useTranslation();
  const flowItemData = flowItemDataMap[ingressNodeId];

  const isIngressSelected = (so: ServiceOperation, ingress: IngressEvent) => so.serviceOperation === flowItemData.serviceOperationName
    && ingress.ingressEventName === flowItemData.ingressEvent
    && Number(ingress.ingressEventVersion) === flowItemData.ingressEventVersion;

  return (
    <>
      <div className={classes['sidebar-heading']} data-testid="ingressEventsSideBarHeader">
        <div className={classes['close-sidebar']}>
          <p className={classes['sidebar-title']} data-testid="sidebarTitle">{flowItemData.serviceName}</p>
          <Button variant="tertiary" data-testid="sidebarCloseBtn" onClick={hideSidebar}>
            <i className="fa-solid fa-xmark" />
          </Button>
        </div>
        <hr className={classes.separator} />
      </div>
      {
        sidebarDataLoadingState === SidebarDataLoadingState.NONE && (
          <Col data-testid="ingressEventsSideBar" className={classes.ingressEventsSideBar}>
            <h4 className="mt-3">
              <b>
                {translate('journey_builder_component.txt_service_ops_list', { count: serviceOperations.length })}
              </b>
            </h4>
            {serviceOperations.length > 0 ? (
              serviceOperations.map((so) => (
                <React.Fragment key={so.serviceOperation}>
                  <div className={classes['service-op']} key={so.serviceOperation}>
                    <h4><MyIcon name="bottonArrowIcon" /> {so.serviceOperation}</h4>
                    {so.ingressEvents.map((ingress) => (
                      <JourneyCanvasIngressEventItem
                        eventName={ingress.ingressEventName}
                        eventVersion={Number(ingress.ingressEventVersion)}
                        onClick={() => ingressEventClickHandler(so, ingress)}
                        selected={isIngressSelected(so, ingress)}
                        key={`${so.serviceOperation}_${ingress.ingressEventName}_${ingress.ingressEventVersion}`}
                        readOnly={readOnly}
                      />
                    ))}
                  </div>
                  <hr className={classes.separator} />
                </React.Fragment>
              ))
            ) : (
              <p className={classes['no-data']}>
                {translate('journey_builder_component.txt_no_service_ops')}
              </p>
            )}
          </Col>
        )
      }
    </>
  );
};

export default IngressEvents;
